import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/core/auth/auth-context";
import { AuthLoadingFallback } from "@/core/auth/auth-loading-fallback";
import { navPaths } from "@/core/constants";

export const ProtectedLayout = () => {
  const { status, session } = useAuth();

  if (status === "loading") {
    return <AuthLoadingFallback />;
  }

  if (status === "unauthenticated" || !session) {
    return <Navigate to={navPaths.login} replace />;
  }

  return <Outlet />;
};
